import { createAction, props } from '@ngrx/store';
import { ConfirmationDialog } from '../../models/confirmation-dialog';

export const openDashboardConfirmationDialog = createAction(
  '[Dashboard] Open Dashboard Confirmation Dialog',
  props<{ dialogData: ConfirmationDialog }>()
);
